"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentValidationService = void 0;
var ContentValidationService_1 = require("./implementation/ContentValidationService");
exports.contentValidationService = new ContentValidationService_1.ContentValidationService();
//# sourceMappingURL=index.js.map